export default {
	a: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'vip', name: 'VIP', color: 'danger'},
		disabled: false
	},
	b: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'vip', name: 'VIP', color: 'danger'},
		disabled: false
	},
	c: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'vip', name: 'VIP', color: 'danger'},
		disabled: false
	},
	d: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'vip', name: 'VIP', color: 'danger'},
		disabled: false
	},
	e: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'business', name: 'Бизнес', color: 'warning'},
		disabled: false
	},
	f: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'business', name: 'Бизнес', color: 'warning'},
		disabled: false
	},
	g: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'business', name: 'Бизнес', color: 'warning'},
		disabled: false
	},
	h: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'business', name: 'Бизнес', color: 'warning'},
		disabled: false
	},
	i: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'business', name: 'Бизнес', color: 'warning'},
		disabled: false
	},
	j: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, '', '', '', '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},
	k: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},

	l: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},
	m: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},
	n: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, '', '', '', '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},
	o: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},
	p: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, '', '', '', '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},
	q: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},
	r: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},
	s: {
		items: ['', '', '', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	},
	t: {
		items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, '', '', ''],
		meta: {level: 'standard', name: 'Стандарт', color: 'default'},
		disabled: false
	}
}



// WEBPACK FOOTER //
// ./src/data.js